import { Component } from "preact";
import { connectWithTranslations } from "../../common/helpers/translationsHelpers";
import actions from "../../calendar-settings/actions";
import { CALENDAR_VIEW } from "../constants/view";
import { getKeysOfNotNullValues } from "../../common/helpers/objects";
import { GTM_ID, GA4EVENT} from "../constants";
const translations = {
    vi: () =>
        import(/*webpackChunkName: 'configure-view-vi'*/ "../translations/vi"),
    ar: () =>
        import(/*webpackChunkName: 'configure-view-ar'*/ "../translations/ar"),
    de: () =>
        import(/*webpackChunkName: 'configure-view-de'*/ "../translations/de"),
    en: () =>
        import(/*webpackChunkName: 'configure-view-en'*/ "../translations/en"),
    es: () =>
        import(/*webpackChunkName: 'configure-view-es'*/ "../translations/es"),
    fr: () =>
        import(/*webpackChunkName: 'configure-view-fr'*/ "../translations/fr"),
    id: () =>
        import(/*webpackChunkName: 'configure-view-id'*/ "../translations/id"),
    ru: () =>
        import(/*webpackChunkName: 'configure-view-ru'*/ "../translations/ru"),
    tr: () =>
        import(/*webpackChunkName: 'configure-view-tr'*/ "../translations/tr"),
    "zh-cht": () =>
        import(
            /*webpackChunkName: 'configure-view-zh-cht'*/ "../translations/zh-cht"
        ),
    "zh-cn": () =>
        import(
            /*webpackChunkName: 'configure-view-zh-cn'*/ "../translations/zh-cn"
        ),
    fa: () =>
        import(/*webpackChunkName: 'configure-view-fa'*/ "../translations/fa"),
    pt: () =>
        import(/*webpackChunkName: 'configure-view-pt'*/ "../translations/pt"),
    cs: () =>
        import(/*webpackChunkName: 'configure-view-cs'*/ "../translations/cs"),
};
class ConfigureView extends Component {
    componentWillMount() {
        translations[
            this.props.locale ? this.props.locale.toLowerCase() : "en"
        ]().then((t) => {
            this.setState({ translations: t.default });
        });
    }

    getGTMTracking(view) {
        switch (view) {
            case CALENDAR_VIEW.Configure_View_Basic:
                return GTM_ID.CONFIGURATION_BASIC_VIEW;
            case CALENDAR_VIEW.Configure_View_Default:
                return GTM_ID.CONFIGURATION_DEFAULT_VIEW;
            case CALENDAR_VIEW.Configure_View_Premium:
                return GTM_ID.CONFIGURATION_PREMIUM_VIEW;
        }
    }
    getGA4Tracking(view) {
        switch (view) {
            case CALENDAR_VIEW.Configure_View_Basic:
                return GA4EVENT.ELEMENTS.CONFIGURATION_BASIC_VIEW;
            case CALENDAR_VIEW.Configure_View_Default:
                return GA4EVENT.ELEMENTS.CONFIGURATION_DEFAULT_VIEW;
            case CALENDAR_VIEW.Configure_View_Premium:
                return GA4EVENT.ELEMENTS.CONFIGURATION_PREMIUM_VIEW;
        }
    }

    render(
        { config, view, onOptionSelected, showDescription },
        { translations }
    ) {
        if (!translations) return null;

        const keys = getKeysOfNotNullValues(CALENDAR_VIEW).filter(
            (key) => key != "Configure_View_Premium" || config.hasPremium
        );

        return (
            <div class={`fxs_c${showDescription ? "s" : ""}_configure_view`}>
                <h2 class="fxs_headline_small">
                    {translations.Configure_View_Title}
                </h2>
                <p class="fxs_entryPlain_txt">
                    {translations.ConfigureView_Summary}
                </p>
                <form
                    class={`fxs_c${showDescription ? "s" : ""}_view_selector`}
                >
                    {keys.map((key) => (
                        <div
                            class={`fxs_c${
                                showDescription ? "s" : ""
                            }_view_item ${
                                view === CALENDAR_VIEW[key]
                                    ? `fxs_c${
                                          showDescription ? "s" : ""
                                      }_view_item_active`
                                    : ""
                            }
                            ${
                                CALENDAR_VIEW.Configure_View_Premium ===
                                CALENDAR_VIEW[key]
                                    ? `fxs_c${
                                          showDescription ? "s" : ""
                                      }_view_item_disabled`
                                    : ""
                            }
                            ${
                                config.hasPremium
                                    ? ""
                                    : "fxs_cs_premium_disabled"
                            }
                            `}
                        >
                            <label
                                onClick={() =>
                                    onOptionSelected(CALENDAR_VIEW[key])
                                }
                                class={`fxs_c${
                                    showDescription ? "s" : ""
                                }_view_item_selector`}
                            >
                                <input
                                    type="radio"
                                    name="viewOption"
                                    class={`fxs_c${
                                        showDescription ? "s" : ""
                                    }_view_item_checkbox`}
                                    data-gtmid={
                                        config.tracking &&
                                        this.getGTMTracking(CALENDAR_VIEW[key])
                                    }
                                    data-ga4event-clk-name={ config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR}
                                    data-ga4event-element = {this.getGA4Tracking(CALENDAR_VIEW[key])}                                    
                                    onClick={() =>
                                        onOptionSelected(CALENDAR_VIEW[key])
                                    }
                                    checked={view === CALENDAR_VIEW[key]}
                                    disabled={
                                        CALENDAR_VIEW[key] ===
                                        CALENDAR_VIEW.Configure_View_Premium
                                    }
                                />

                                <span
                                    class={`fxs_c${
                                        showDescription ? "s" : ""
                                    }_view_item_label fxs_entryPlain_txt`}
                                >
                                    {translations[key]}
                                </span>

                                {showDescription && (
                                    <span
                                        class={`fxs_cs_view_description fxs_txt_size_xsmall ${
                                            CALENDAR_VIEW.Configure_View_Premium ===
                                            CALENDAR_VIEW[key]
                                                ? "fxs_marginBase_top"
                                                : ""
                                        }`}
                                    >
                                        {translations[key + "_Summary"]}
                                    </span>
                                )}

                                {showDescription &&
                                    CALENDAR_VIEW.Configure_View_Premium ===
                                        CALENDAR_VIEW[key] && (
                                        <p>
                                            <a
                                                data-gtmid={
                                                    config.tracking &&
                                                    GTM_ID.CONFIGURATION_PREMIUM_LINK
                                                }
                                                data-ga4event-clk-name={ config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR}
                                                data-ga4event-element = { config.tracking && GA4EVENT.ELEMENTS.CONFIGURATION_PREMIUM_LINK}
                                                href={config.premiumUrl}
                                                target="_blank"
                                                class="fxs_cs_view_premium fxs_txt_size_xsmall"
                                            >
                                                {translations.Premium_More_Info}
                                            </a>
                                        </p>
                                    )}
                            </label>
                        </div>
                    ))}
                </form>
            </div>
        );
    }
}

export default connectWithTranslations(
    "settings, config",
    actions
)(ConfigureView);
